import { render, staticRenderFns } from "./EventsSummary.vue?vue&type=template&id=97a57ae0&scoped=true&"
import script from "./EventsSummary.vue?vue&type=script&lang=js&"
export * from "./EventsSummary.vue?vue&type=script&lang=js&"
import style0 from "./EventsSummary.vue?vue&type=style&index=0&id=97a57ae0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a57ae0",
  null
  
)

export default component.exports